import ExpanderPanel from '@rio-cloud/rio-uikit/ExpanderPanel';
import { FormattedMessage } from 'react-intl';
import { HighlightedMessage } from '../registration/LooseObject';
import { useAppSelector } from '../../configuration/setup/hooks';
import { config } from '../../config';
import { getPersonalInfoEmail } from '../personal/personalInfoSlice';

const FinishedHeader = () => (
    <>
        <div className={'text-size-h2 margin-bottom-20 display-flex align-items-center max-width-100pct'}>
            <span className={'uikit-icon icon-envelope-open text-color-highlight text-size-300pct'} />
        </div>

        <div
            className={
                'text-size-h3 text-size-h2-xl line-height-125rel text-color-dark text-medium width-500 max-width-100pct text-wrap-balance'
            }
        >
            <FormattedMessage id={'registration.activateAccount.heading'} />
        </div>
    </>
);

const EmailSentConfirmation = () => {
    const email = useAppSelector(getPersonalInfoEmail);
    return (
        <>
            <p>
                <HighlightedMessage
                    textId={'registration.activateAccount.text1'}
                    highlightClass={'text-bold'}
                    highlightKeys={['activationLink']}
                />
            </p>
            <p className={'text-size-largest text-size-16'}>
                <strong>{email}</strong>
            </p>
        </>
    );
};

const EmailHelp = () => (
    <div className={'text-left text-wrap-pretty'}>
        <ExpanderPanel title={<FormattedMessage id={'registration.activateAccount.noMail'} />} bsStyle={'default'}>
            <ul>
                <li>
                    <FormattedMessage id={'registration.activateAccount.checkSpamFolder'} />
                </li>
                <li>
                    <FormattedMessage id={'registration.activateAccount.checkEmailValid'} />
                </li>
            </ul>
        </ExpanderPanel>
    </div>
);

const LoginNowField = () => (
    <div className={'margin-top-25 margin-bottom-50 display-flex justify-content-center'}>
        <a className={'btn btn-primary btn-lg'} href={config.homeRoute}>
            <FormattedMessage id={'registration.loginNow'} />
        </a>
    </div>
);

export const Finished = () => (
    <div className={'RegistrationPanelContainer panel-default panel panel-body padding-25'}>
        <div className={'display-flex justify-content-center max-width-100pct'}>
            <div className={'margin-0 width-100pct max-width-600 panel-default panel padding-15 border-none'}>
                <div className={'display-flex flex-column align-items-center text-center padding-25'}>
                    <FinishedHeader />
                    <div className={'text-color-dark margin-top-15 width-500 max-width-100pct text-wrap-balance'}>
                        <div className={'text-wrap-balance'}>
                            <EmailSentConfirmation />
                            <LoginNowField />
                        </div>
                        <EmailHelp />
                    </div>
                </div>
            </div>
        </div>
    </div>
);
